import { Tooltip } from './Tooltip';
import { Popover } from './Popover';

export const Above = {
  Tooltip,
  Popover,
};
